import { graphql } from 'gatsby'
import tw, { TwStyle } from 'twin.macro'

import DynamicAction from '@/components/ui/dynamic-action'
import ImageContentful from './ui/image-contentful'

export const fragment = graphql`
  fragment HeaderCardLink on ContentfulHeaderCardLink {
    __typename
    id
    link {
      ...CtaLink
    }
    description {
      content: description
    }
    shortDescription {
      content: shortDescription
    }
  }

  fragment HeaderCard on ContentfulHeaderCard {
    __typename
    id
    contentful_id
    headline
    subtext {
      subtext
    }
    image {
      ...Asset
    }
    links {
      ...HeaderCardLink
    }
  }
`

type HeaderCardProps = Queries.HeaderCardFragment & {
  className?: string
  css?: TwStyle | TwStyle[]
  onLinkClick?: () => void
}

export default function HeaderCard({ className, css, headline, subtext, links, image, onLinkClick }: HeaderCardProps) {
  return (
    <div className={className} css={[tw``, css]}>
      <h5 tw="text-2xl font-[500] text-indigoBlue flex mb-1">
        {image && (
          <div tw="hidden md:block w-8 h-8 mr-[0.875rem]">
            <ImageContentful {...image} tw="[svg]:w-full [svg]:h-full [path]:fill-indigoBlue!" />
          </div>
        )}
        <span>{headline}</span>
      </h5>
      {subtext && <p tw="text-base leading-6 mb-[1.125rem] text-[#545E66]">{subtext.subtext}</p>}
      {links?.length > 0 && (
        <div tw="grid md:(grid-rows-subgrid grid-flow-col) lg:(flex flex-row flex-nowrap content-stretch) gap-5 md:gap-9">
          {links.map((link) => (
            <div
              key={link.id}
              tw="relative md:flex-[0 1 280px] bg-white rounded-2xl px-[1.125rem] pt-3 pb-4 flex-1 transition-shadow hover:shadow-lg duration-300"
            >
              <DynamicAction
                key={link.link.id}
                tw="stretched-link no-underline text-primaryBlue! hover:text-indigoBlue! transition-colors text-base leading-[120%] self-start py-0!"
                onClick={onLinkClick}
                {...(link.link as any)}
              />
              {link.description?.content && (
                <p tw="text-sm text-[#545E66] md:hidden mb-0">{link.description.content}</p>
              )}
              {link.shortDescription?.content && (
                <p tw="text-sm text-[#545E66] hidden md:block mb-0">{link.shortDescription.content}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
